/** Phase 18 — supplierDebts lesen. */

import { listAggregateSupplierDebts } from '../infrastructure/storage/domainAggregateStore';
import { listEntitySupplierDebts } from '../infrastructure/storage/entityAggregateStore';
import { createArrayEntityReadSource } from './arrayEntityReadSourceFactory';

const source = createArrayEntityReadSource({
  field: 'supplierDebts',
  listAggregate: listAggregateSupplierDebts,
  listEntity: listEntitySupplierDebts,
  idKeys: ['id', 'supplierId']
});

export const readSupplierDebtsFromMergedBlob = source.readFromMergedBlob;
export const readSupplierDebtsFromBestSource = source.readFromBestSource;
export const refreshSupplierDebtsReadCache = source.refreshReadCache;
export const getCachedSupplierDebtsRead = source.getCachedRead;
export const clearSupplierDebtsReadCache = source.clearReadCache;
export const readSupplierDebtsSyncForBusiness = source.readSyncForBusiness;
